import { render, staticRenderFns } from "./AlertPolicyTable.vue?vue&type=template&id=d70d62b2"
import script from "./AlertPolicyTable.vue?vue&type=script&lang=js"
export * from "./AlertPolicyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports